import React from "react"
import styles from "../styles/components/googleMap.module.scss"

const GoogleMap = () => (
  <iframe
    className={styles.map}
    title="Find Lifetime Fitness in Sri Jayawardenepura Kotte"
    src="https://maps.google.com/maps?q=Lifetime%20Fitness%2C%20709%2F6%20Pannipitiya%20Road%2C%20Sri%20Jayawardenepura%20Kotte&t=&z=16&ie=UTF8&iwloc=&output=embed"
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    allowFullScreen
  />
)
export default GoogleMap
